export default __webpack_public_path__ + "8247e42e22a0a2b0fdd344d7dff69760.png";